import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductType } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { PlansPageConfig } from 'src/app/interfaces/pageConfig';

/**
 * The three plan cards with their pricing and select behaviour, so pages that
 * show the grid don't each re-derive it. Copy and prices come from the shared
 * `plans` page config, the same source the membership options step reads.
 */
@Component({
  selector: 'app-plan-grid',
  templateUrl: './plan-grid.component.html',
})
export class PlanGridComponent {
  public isIdentiSmartTagPlanAvailable: boolean;

  public page: PlansPageConfig;
  public basePlanSubtitle: string;
  public alertPlanSubtitle: string;
  public locatorPlanSubtitle: string;

  public plan1YearlyPrice: string;
  public plan2YearlyPrice: string;
  public plan3YearlyPrice: string;
  public plan3YearlyPriceOriginal: string;

  private plan1Route: string;
  private plan2Route: string;
  private plan3Route: string;

  constructor(
    private _router: Router,
    private authManager: AuthManagerService,
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService,
    private paymentConfigService: PaymentConfigService,
  ) {
    this.page = this.configService.getPage('plans');
    this.basePlanSubtitle = this.withPetName(this.page.basePlan.subtitle);
    this.alertPlanSubtitle = this.withPetName(this.page.alertPlan.subtitle);
    this.locatorPlanSubtitle = this.withPetName(this.page.locatorPlan.subtitle);

    this.plan1Route = this.configService.getTextFromKey('1-plan-route');
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.plan3Route = this.configService.getTextFromKey('3-plan-route');

    this.plan1YearlyPrice = this.configService.getTextFromKey('1-plan-yearly-price');
    this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
    this.plan3YearlyPrice = this.configService.getTextFromKey('3-plan-yearly-price');
    this.plan3YearlyPriceOriginal = this.configService.getTextFromKey('3-plan-yearly-price-original');

    // Falls back to config when the backend offers no price (signed-out visitors included).
    this.plan1YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.BasicPlus) ?? this.plan1YearlyPrice;
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan3YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Locator) ?? this.plan3YearlyPrice;

    this.isIdentiSmartTagPlanAvailable = this.featureFlagService.isEnabled('isIdentiSmartTagPlanAvailable');
  }

  // No pet in context on these pages, so the placeholder always takes the fallback.
  private withPetName(text: string): string {
    return text?.replace('{{petName}}', 'Your pet');
  }

  public selectBase(): void {
    this.goToProductPage(this.plan1Route);
  }

  public selectAlert(): void {
    this.goToProductPage(this.plan2Route);
  }

  public selectLocator(): void {
    this.goToProductPage(this.plan3Route);
  }

  // Signed-out visitors are sent to log in first, then back to the plan's product page.
  private goToProductPage(productPageRoute: string): void {
    if (!this.authManager.isAuthenticated) {
      this._router.navigate(['/login-register'], { queryParams: { r: productPageRoute } });
      return;
    }

    this._router.navigate([productPageRoute]);
  }
}
